import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RecurringPaymentCardData } from '../recurring-payment-card-data';

@Component({
  selector: 'app-vb-payments-recurring-payment-card',
  templateUrl: './vb-payments-recurring-payment-card.component.html',
  styleUrls: ['./vb-payments-recurring-payment-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsRecurringPaymentCardComponent {
  @Input({ required: true }) cardData!: RecurringPaymentCardData;
  @Input({ required: true }) cardTitle!: string;
  @Input({ required: true }) frequencyLabel!: string;
}
